import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { createContext, useEffect, useState } from 'react';

import { initialData, type InitialData } from 'utils/mock/connectInitialData';

export type ConnectDataContext = {
  data: InitialData | null;
  setData: Dispatch<SetStateAction<InitialData | null>>;
};

const defaultValue: ConnectDataContext = {
  data: null,
  setData: () => {},
};

/**
 * Connectの入力された値を管理する
 */
export const ConnectDataContext = createContext(defaultValue);

export const ConnectDataProvider = ({ children }: { children: ReactNode }) => {
  const [data, setData] = useState<InitialData | null>(null);

  useEffect(() => {
    // TODO: バックエンドからデータを取得する
    setData(initialData);
  }, []);

  return (
    <ConnectDataContext.Provider
      value={{
        data,
        setData,
      }}
    >
      {children}
    </ConnectDataContext.Provider>
  );
};
